import { lazy } from 'react';

import { Navigate, Route } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import ProtectedLayout from '@layouts/ProtectedLayout';
import RequireAuth from '@routes/guards/RequireAuth';

const DashboardPage = lazy(() => import('@pages/Dashboard'));
const UsersPage = lazy(() => import('@pages/Users'));
const PlaceholderPage = lazy(() => import('@pages/Placeholder'));

const ProtectedRoutes = (
  <Route element={<RequireAuth />}>
    <Route element={<ProtectedLayout />}>
      <Route index element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
      <Route path={ROUTES.USERS} element={<UsersPage />} />
      <Route path={ROUTES.CLIENTS} element={<PlaceholderPage title="Clients" />} />
      <Route path={ROUTES.REALTORS} element={<PlaceholderPage title="Realtors" />} />
      <Route path={ROUTES.EVENTS} element={<PlaceholderPage title="Events" />} />
      <Route path={ROUTES.REPORTS} element={<PlaceholderPage title="Reports" />} />
      <Route path={ROUTES.INVOICES} element={<PlaceholderPage title="Invoices" />} />
      <Route path={ROUTES.PAYMENTS} element={<PlaceholderPage title="Payments" />} />
      <Route path={ROUTES.BUSINESS} element={<PlaceholderPage title="Business" />} />
      <Route path={ROUTES.SETTINGS} element={<PlaceholderPage title="Settings" />} />
      <Route path={ROUTES.HELP} element={<PlaceholderPage title="Help" />} />
    </Route>
  </Route>
);

export default ProtectedRoutes;
